import MenuBar from "../Component/MenuBar";
import PageBanner from '../Component/PageBanner';
import Sidebar from '../Component/Sidebar';
import Footer from "../Component/Footer";
const GlobalSeva = () => {
  return (
    <>
          
    <MenuBar />
    <Sidebar />
      {/* <!-- Page Banner Section --> */}
      <PageBanner title="Global Seva Mission" />

      {/* <!--End Banner Section --> */}

      <div className="container">



        <div className="auto-container">

          <div className="centered">
            <hr />
            <h3> Global Seva Mission </h3>
            <hr />
            <a href="https://ykportal.yugalkunj.org/?ParamCountry=USA" target="_blank" className="alert alert-primary">
              <span className="btn-title"><span className="fa fa-2x fa fa-hand-o-right"></span>  Please click here for registration </span>
            </a>
            <hr />
          </div>
        </div>

        <div className="row">

          <div className="col-lg-12">
            <div className="card card-margin">
              <div className="card-header no-border">
                <h5 className="card-title"> Global Seva Mission</h5>

              </div>
              <div className="card-body pt-0">
                <div className="widget-49">


                  <figure className="image">
                    <img src="https://stssevastorage.blob.core.windows.net/ykportal/YK%20GSM%20-%20Brochure_2024.jpg" alt="" />
                    <a href="https://stssevastorage.blob.core.windows.net/ykportal/YK%20GSM%20-%20Brochure_2024.jpg" className="lightbox-image overlay" data-fancybox="gallery-two"></a>
                  </figure>
                  <br />
                  <div className="widget-49-meeting-action">
                    <a href="https://stssevastorage.blob.core.windows.net/ykportal/Global%20Seva_2024.pdf" target="_blank" className="btn btn-sm btn-flash-border-primary">View Flyer</a>
                  </div>

                </div>
              </div>
            </div>
          </div>


        </div>



      </div>
      <Footer />
   
    </>
  )
}

export default GlobalSeva
